import { MouseEvent } from 'react';
import { ExternalLink, LucideIcon } from 'lucide-react';
import { buttonVariants } from '../ui/button';
import { cn } from '../../lib/utils';
import type { VariantProps } from 'class-variance-authority';

type DatapipeLinkProps = {
    href: string | null;
    label: string;
    icon?: LucideIcon;
    variant?: VariantProps<typeof buttonVariants>['variant'];
    size?: VariantProps<typeof buttonVariants>['size'];
    className?: string;
};

// Opens a passive-implant page in the ni-datapipe app in a new tab. Renders nothing
// when no datapipe URL is configured. Clicks never bubble, because the rows
// that host this link navigate on click themselves.
const DatapipeLink = ({
    href,
    label,
    icon: Icon = ExternalLink,
    variant = 'outline',
    size = 'sm',
    className,
}: DatapipeLinkProps) => {
    if (!href) return null;
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event: MouseEvent<HTMLAnchorElement>) =>
                event.stopPropagation()
            }
            className={cn(buttonVariants({ variant, size }), className)}
        >
            <Icon />
            {label}
        </a>
    );
};

export default DatapipeLink;
